<template>
  <!-- 消息中心 -->
  <div class="container">
    <div class="white-bg">
      <div class="g-p-30">
        <div class="tabs g-flex">
          <div class="tab-item g-rela"
               :class="{'main-text':index === tabNow}"
               v-for="(item,index) in tabList"
               :key="index"
               @click="tabChange(index)"
          >
            {{ item.name }}
            <div class="active-bar-line" v-if="tabNow === index"></div>
            <div class="nums" v-if="item.num>0">
              <!-- {{ item.num>99?'99+':item.num }} -->
            </div>
          </div>
        </div>
        <!--  招聘消息  -->
        <div v-if="tabNow === 0">
          <div class="list-item g-m-t-20" v-for="(item,index) in dataList" :key="index">
            <div class="g-flex">
              <div class="head-tag g-flex">
                <img src="@/assets/mine/news-list-item-tag.png" class="tag-icon" alt="">
                <p class="g-font-16 g-m-l-10">{{ item.title }}</p>
              </div>
            </div>
           <div class="g-flex g-row-between g-m-t-15">
              <p class="yellow-text g-font-14" v-if="item.businessObj.status == 1">您收到一个面试邀请，请尽快处理！</p>
              <p class="green-text g-font-14" v-if="item.businessObj.status == 2">您已接受邀请，请按约定时间进行面试！</p>
			   <p class="red-text g-font-14" v-if="item.businessObj.status == 3">您已拒绝面试邀请！</p>
              <p class="remark-text g-font-14">{{ item.createTime }}</p>
            </div>

            <div class="info-box g-m-t-15">
              <div class="g-p-20">
                <div class="g-flex g-row-between">
                  <p class="g-font-18 main-text g-weight-font">
					{{item.businessObj.employPostName==''?item.businessObj.postName:item.businessObj.employPostName}}
					<span class="g-m-l-20 remark-text g-font-14" v-if="item.businessObj.workYear">{{item.businessObj.education}}|{{item.businessObj.workYear}}年经验</span>
				  </p>
                  <p class="g-font-16 yellow-text g-weight-font" v-if="item.businessObj.salary">{{item.businessObj.salary}}</p>
                </div>
                <div class="g-flex g-row-between g-m-t-20">
                  <div class="g-flex">
                    <!-- <img :src="item.storeIcon" class="store-icon" alt=""> -->
                    <p class="g-m-l-15 g-font-14 sub-text">{{ item.businessObj.orgName }}</p>
                    <p class="g-m-l-36 remark-text g-font-14">{{ item.businessObj.orgAddress }}</p>
                  </div>
                  <div class="submit-btn" @click="openShow1(item)">
                    {{item.businessObj.status == 1?'查看面试邀请':'查看邀请详情'}}
                  </div>
                  <!-- <div class="submit-btn" v-else @click="openShow1(item)">
                    查看邀请详情
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!--  分页  -->
          <div class="g-flex g-row-center g-m-t-30">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total1">
            </el-pagination>
          </div>
        </div>

        <!--  课程订单  -->
        <div v-if="tabNow === 1"
             v-loading="loading2"
             element-loading-text="拼命加载中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.5)">
          <div class="order-item g-rela g-m-t-20" v-for="(item,index) in dataList2" :key="index">
            <div class="sn g-font-18 g-p-t-20 g-weight-font">
              {{ '订单编号:' + item.outTradeNo }}
            </div>
            <div class="row-line"></div>

            <div class="g-flex g-row-between g-font-14">
              <!--  待支付  -->
              <p class="yellow-text" v-if="item.status === 0">
                <span>您有一个订单将在</span>
                <span class="g-m-l-10 g-m-r-10">{{ item.timeMsg }}</span>
                <span>后自动取消</span>
                <span>，请尽快支付</span>
              </p>
              <!--  已支付  -->
              <p class="yellow-text" v-if="item.status === 1">
                订单支付成功，快去学习吧
              </p>
              <!--  已取消  -->
              <p class="yellow-text" v-if="item.status === 2">
                您的订单未在规定时间内完成支付被取消了
              </p>
              <p class="remark-text ">{{ item.createTime }}</p>
            </div>
            <div class="info-box g-m-t-10">
              <div class="g-flex g-row-between g-col-top g-p-20">
                <img :src="item.cover" class="order-img" alt="">
                <div class="g-m-l-20 g-m-t-10">
                  <p class="g-font-16 main-text">{{ item.name }}</p>
                  <p class="g-m-t-10 g-font-12 remark-text">{{ item.desc }}</p>
                </div>
                <div class="g-flex-right g-text-center">
                  <div class="red-text money-text g-font-18 g-weight-font" v-if="item.price  === '0.00'">
                    免费
                  </div>
                  <div class="red-text money-text g-font-18 g-weight-font" v-else>
                    {{ '￥' + item.price }}
                  </div>
                  <!--  待支付  -->
                  <div class="submit-btn g-m-t-30" v-if="item.status === 0" @click="doPay(item)">
                    立即支付
                  </div>
                  <!--  已支付  -->
                  <div class="submit-btn g-m-t-30" v-if="item.status === 1" @click="goPage('/course-detail',item)">
                    立即学习
                  </div>
                  <!--  查看课程  -->
                  <div class="submit-btn g-m-t-30" v-if="item.status === 2" @click="goPage('/course-detail',item)">
                    查看课程
                  </div>
                </div>
              </div>
            </div>

            <div class="order-status-tag">
              {{ item.status === 0 ? '待支付' : item.status === 1 ? '已支付' : '已取消' }}
            </div>
          </div>
          <!--  分页  -->
          <div class="g-flex g-row-center g-m-t-30">
            <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="page2.current"
                :page-sizes="[25, 50, 100]"
                :page-size="page2.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total2">
            </el-pagination>
          </div>
        </div>

        <!--  系统通知  -->
        <div v-if="tabNow === 2">
          <div class="sys-item g-m-t-20" v-for="(item,index) in dataList3" :key="index">
            <div class="g-p-20 g-flex g-col-top g-row-between">
              <div>
                <p class="g-font-18 g-weight-font">{{ item.title }}</p>
                <p class="g-m-t-15 g-font-14 green-text">{{ item.content }}</p>
              </div>
              <div>
                <p class="remark-text g-font-14">{{ item.createTime }}</p>
                <div class="g-m-t-16 submit-btn" @click="showPopup3(item)">查看详情</div>
              </div>
            </div>
          </div>
          <!--  分页  -->
          <div class="g-flex g-row-center g-m-t-30">
            <el-pagination
                @size-change="handleSizeChange3"
                @current-change="handleCurrentChange3"
                :current-page="page3.current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="page3.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total3">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!--  查看面试邀请  -->
    <el-dialog
        :visible.sync="show1"
        class="popup1"
        width="31%">
      <div class="g-text-center g-p-b-15 border-bottom g-font-20 g-weight-font">
        面试邀请
      </div>
      <p class="g-m-t-20 remark-text g-font-16">
        面试岗位
      </p>
      <div class="info-box g-m-t-10">
        <div class="g-p-20">
          <div class="g-flex g-row-between">
            <p class="g-font-18 main-text g-weight-font">{{selected.businessObj.employPostName==''?selected.businessObj.postName:selected.businessObj.employPostName}}</p>
            <p class="g-font-16 yellow-text g-weight-font">{{selected.businessObj.salary}}</p>
          </div>
          <div class="g-flex g-row-between g-m-t-20">
            <div class="g-flex g-full-width">
              <p class=" g-font-14 sub-text">{{selected.businessObj.employDeptName==''?selected.businessObj.orgName:selected.businessObj.employDeptName}}</p>
              <p class="g-m-l-36 remark-text g-font-14">
                {{selected.businessObj.positionInfo}}
              </p>
              <p class="g-flex-right main-text g-font-14">{{selected.businessObj.orgAddress }}</p>
            </div>
          </div>
        </div>
      </div>
     <div class="g-m-t-15 g-flex g-font-16">
       <p class="label remark-text ">联系人</p>
       <p class="g-m-l-30 main-text">{{selected.businessObj.orgContacts}}</p>
     </div>
     <div class="g-m-t-15 g-flex g-font-16">
       <p class="label remark-text ">联系电话</p>
       <p class="g-m-l-30 main-text">{{selected.businessObj.orgMobile}}</p>
     </div>
     <div class="g-m-t-15 g-flex g-font-16">
       <p class="label remark-text ">面试时间</p>
       <p class="g-m-l-30 main-text">{{selected.businessObj.interviewTime}}</p>
     </div>
     <div class="g-m-t-15 g-flex g-font-16">
       <p class="label remark-text ">面试地点</p>
       <p class="g-m-l-30 main-text">{{selected.businessObj.orgAddress}}</p>
     </div>
      <div class="g-flex g-row-center g-m-t-30" v-if="selected.businessObj.status==1">
        <div class="btn" @click="show1 = false">再想想</div>
        <div class="btn g-m-l-20" @click="doAccept(selected.businessObj.id,3)">拒绝邀请</div>
        <div class="submit-btn g-m-l-20" @click="doAccept(selected.businessObj.id,2)">接受面试</div>
      </div>
	  <div class="g-flex g-row-center g-m-t-30" v-else>
	    <div class="btn" @click="show1 = false">关闭</div>
	  </div>
    </el-dialog>

    <!--  接受面试邀请详情  -->
    <el-dialog
        :visible.sync="show2"
        class="popup1"
        width="31%">
      <div class="g-text-center g-p-b-15 border-bottom g-font-20 g-weight-font">
        面试邀请
      </div>
      <p class="g-m-t-20 remark-text g-font-16">
        面试岗位
        <span class="green-text g-m-l-20 g-font-14">您已接受邀请，请按约定时间进行面试</span>
      </p>
      <div class="info-box g-m-t-10">
        <div class="g-p-20">
          <div class="g-flex g-row-between">
            <p class="g-font-18 main-text g-weight-font">{{ selected.position }}</p>
            <p class="g-font-16 yellow-text g-weight-font">{{ selected.salary }}</p>
          </div>
          <div class="g-flex g-row-between g-m-t-20">
            <div class="g-flex g-full-width">
              <p class=" g-font-14 sub-text">{{ selected.storeName }}</p>
              <p class="g-m-l-36 remark-text g-font-14">
                {{ selected.positionInfo }}
              </p>
              <p class="g-flex-right main-text g-font-14">{{ selected.storePosition }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="g-m-t-15 g-flex g-font-16">
        <p class="label remark-text ">联系人</p>
        <p class="g-m-l-30 main-text">{{selected.businessObj.orgContacts}}</p>
      </div>
      <div class="g-m-t-15 g-flex g-font-16">
        <p class="label remark-text ">联系电话</p>
        <p class="g-m-l-30 main-text">{{selected.businessObj.orgMobile}}</p>
      </div>
      <div class="g-m-t-15 g-flex g-font-16">
        <p class="label remark-text ">面试时间</p>
        <p class="g-m-l-30 main-text">{{selected.businessObj.interviewTime}}</p>
      </div>
      <div class="g-m-t-15 g-flex g-font-16">
        <p class="label remark-text ">面试地点</p>
        <p class="g-m-l-30 main-text">{{selected.businessObj.orgAddress}}</p>
      </div>
      <div class="g-flex g-row-center g-m-t-30">
        <div class="btn" @click="show2 = false">关闭</div>
      </div>
    </el-dialog>

    <!--  查看系统通知详情  -->
    <el-dialog
        :visible.sync="show3"
        class="popup1"
        width="31%">
      <div class="g-text-center g-p-b-15 border-bottom g-font-20 g-weight-font">
        {{ selected2.title }}
      </div>
      <div class="g-m-t-15 g-font-16">
        {{ selected2.content }}
      </div>
      <div class="g-flex">
        <div class="remark-text g-font-14 g-flex-right g-m-t-70 g-text-center">
          <p>系统消息</p>
          <p class="g-m-t-10">{{ selected2.createTime }}</p>
        </div>
      </div>
    </el-dialog>
    <!--  付款  -->
    <popup-pay-box ref="payPopup" :courseId="currentOrder.courseId" :price="currentOrder.price"
                   @success="queryCourseOrder"></popup-pay-box>
  </div>
</template>

<script>
import {messageList,messageCount,updateMsgStatus} from "@/api/api.js"
import {sendResumeUpdate} from "@/api/job.js"
import {getCourseOrderPageList} from '@/api/pay'
import PopupPayBox from "@/components/pay-popup";

export default {
  name: "news-center",
  data() {
    return {
      tabNow: 0,//tab下标
      currentOrder: {
        courseId: '',
        price: ''
      },
      tabList: [
        {
          name: '招聘消息',
          id: '1',
          num: 0
        },
        {
          name: '课程订单',
          id: '2',
          num: 0
        },
        {
          name: '系统消息',
          id: '3',
          num: 0
        }
      ],
      dataList: [
        {
          status: 1, //面试邀请,未接受
          title: '面试邀请',
          time: '2022-05-17 12:11:23',
          position: '口腔科主任医师',
          salary: '20k-30k',
          storeName: '蒙自吉祥口腔诊所',
          storePosition: '红河·蒙自',
          storeIcon: '',
          positionInfo: '本科 | 3-5年经验 | 3人'
        },
        {
          status: 2, //面试邀请,已接受
          title: '面试通知',
          time: '2022-05-17 12:11:23',
          position: '口腔科主任医师',
          salary: '20k-30k',
          storeName: '蒙自吉祥口腔诊所',
          storePosition: '红河·蒙自',
          storeIcon: '',
          positionInfo: '本科 | 3-5年经验 | 3人'
        }
      ],//招聘消息
      currentPage: 1,// 招聘消息当前页
      show1: false,//消息通知 弹窗
      show2: false,//消息通知 弹窗
      show3: false,//系统通知弹窗
      selected:{businessObj:{}},//选中招聘的项
      dataList2: [],//课程订单
      currentPage2: 1,//课程分页 当前页
      dataList3: [
        {
          type: 1,//'修改密码
          info: '您已成功修改密码，请不要向其他恩泄露账号密码，以免造成损失！',
          time: '2022-05-17 12:11:23',
          title: '修改密码成功'
        },
        {
          type: 2,//'获得证书
          info: '您已成功修改密码，请不要向其他恩泄露账号密码，以免造成损失！',
          time: '2022-05-17 12:11:23',
          title: '修改密码成功'
        }
      ],
      loading2: false,
      selected2: '',//选中系统通知的项
      page2: {
        current: 1,
        size: 25,
      },
      total2: 0,
	  page1: {
		  current: 1,
		  size: 10,
		  businessType: '2',
		  platform:2
	  },
	  total1: 0,
	  page3: {
		  current: 1,
		  size: 10,
		  source: 0,
		  platform:2
	  },
	  total3: 0
    }
  },
  components: {PopupPayBox},
  created() {
	  this.queryInterviewMsgs()
	this.queryCourseOrder()
	this.querySystemMsgs()
  },
  methods: {
	  queryInterviewMsgs(){
		  messageList(this.page1).then(res => {
			  this.dataList = res.records;
			  this.total1 = res.total;
			  // this.tabList[0].num = res.total;
		  });
		  messageCount({status:0,businessType:'2',platform:2}).then(res=>{
			  this.tabList[0].num = res;
		  });
	  },
    queryCourseOrder() {
      this.loading2 = true
      getCourseOrderPageList(this.page2).then(res => {
        this.loading2 = false
        this.total2 = res.total
        this.dataList2 = res.records.map(v => {
          this.$set(v, 'countTimer', null)
          this.$set(v, 'timeMsg', null)
          return v
        })
        // this.tabList[1].num = res.total
        for (let i in this.dataList2) {
          if (this.dataList2[i].status === 0 && this.dataList2[i].timeExpire > 0) {
            this.countDown(i)
            this.dataList2[i].countTimer = setInterval(() => {
              this.countDown(i)
            }, 1000)
          }
        }
      }, err => {
        this.loading2 = false
      })
		messageCount({status:0,businessType:'7',platform:2,read:1}).then(res=>{
			this.tabList[1].num = res;
		});
    },
	querySystemMsgs(){
		messageList(this.page3).then(res => {
			this.dataList3 = res.records;
			this.total3 = res.total;
			// this.tabList[2].num = res.total;
		})
		messageCount({status:0,source:0,platform:2}).then(res=>{
			this.tabList[2].num = res;
		});
	},
    // tab切换
    tabChange(val) {
      this.tabNow = val;
      // 订单消息列表需要开启倒计时
      if (val === 1) {
        this.queryCourseOrder()

      } else {
        //  tab切换清空定时器
        for (let i in this.dataList2) {
          if (this.dataList2[i].timeExpire) {
            clearInterval(this.dataList2[i].countTimer)
          }
        }
      }
    },
    // 消息 页数切换
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.page1.size = val
	  this.queryInterviewMsgs()
    },
    // 消息 当前页切换
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.page1.current = val
	  this.queryInterviewMsgs()
    },
    // 订单 页数切换
    handleSizeChange2(val) {
      this.page2.size = val
      this.queryCourseOrder()
    },
    // 订单 当前页切换
    handleCurrentChange2(val) {
      this.page2.current = val
      this.queryCourseOrder()
    },
    // 系统通知 页数切换
    handleSizeChange3(val) {
      console.log(`每页 ${val} 条`);
	  this.page3.size = val
	  this.querySystemMsgs()
    },
    // 系统通知 当前页切换
    handleCurrentChange3(val) {
      console.log(`当前页: ${val}`);
	  this.page3.current = val
	  this.querySystemMsgs()
    },
    // 查看面试邀请
    openShow1(val) {
       this.selected = val;
	   this.show1 = true;

	  updateMsgStatus({status:1,id:val.id}).then(res=>{
		  this.tabList[0].num--;
		  this.$store.dispatch('getTotalNewsNum');
	  });
	  //this.$router.push({name:'mine',query:{menuIndex:3}});
    },
	doAccept(id,status) {
		sendResumeUpdate({
			id:id,
			status:status
		}).then(res=>{
			this.show1=false;
			 this.queryInterviewMsgs()
		})
	},
    // 倒计时
    countDown(i) {
      let m, min, s, second
      if (this.dataList2[i].timeExpire > 0) {
        // 分
        m = Math.floor((this.dataList2[i].timeExpire / 60) % 60);
        min = m < 10 ? "0" + m : m;
        // 秒
        s = Math.floor(this.dataList2[i].timeExpire % 60);
        second = s < 10 ? "0" + s : s;
        this.dataList2[i].timeMsg = min + ":" + second;
        this.dataList2[i].timeExpire--;
      } else {
        clearInterval(this.dataList2[i].countTimer);
      }
    },
    //  跳转
    goPage(name, val) {
      this.$router.push(name + '/' + val.courseId)
    },
    //  唤起支付
    doPay(val) {
      this.currentOrder = val
      this.$nextTick(() => {
        this.$refs.payPopup.open()
      })
    },

    // 查看详情
    showPopup3(val) {
		updateMsgStatus({status:1,id:val.id}).then(res=>{
			this.tabList[2].num--;
			this.$store.dispatch('getTotalNewsNum');
		});

		if(val.businessType=='11'||val.businessType=='3'){//修改密码通知
			this.selected2 = val;
			this.show3 = true;
		} else {//证书通知
			this.$router.push({name:'mine',query:{menuIndex:6}});
		}
    },
  }
}
</script>

<style lang="scss" scoped>
.white-bg {
  background: #ffffff;
  border-radius: 5px;
}

::v-deep .el-tabs__item.is-active {
  color: #333;
}

::v-deep .el-tabs__item {
  color: #999;
  font-size: 20px;
  font-weight: 500;
}

.tabs {
  padding-bottom: 10px;
  border-bottom: 1px solid #edf2ff;

  .tab-item {
    margin-right: 70px;
    font-size: 20px;
    color: #999;
    cursor: pointer;
  }

  .main-text {
    color: #333 !important;
    transition: all ease-in 0.2s;
  }

  .active-bar-line {
    position: absolute;
    left: 0;
    bottom: -10px;
    height: 3px;
    width: 80px;
    background: #407aff;
    transition: all ease-in 0.2s;
  }

  .nums {
    position: absolute;
    right: -15px;
    top: -12px;
    // font-size: 10px;
    // color: #fff;
    background: #ff5918;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.list-item {
  padding: 0 20px 20px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);

  .head-tag {
    padding: 10px 15px;
    background: #407aff;
    border-radius: 0 0 20px 20px;
    color: #fff;

    .tag-icon {
      width: 26px;
      height: 26px;
    }
  }

  .store-icon {
    width: 30px;
    height: 30px;
    border-radius: 5px;
  }

  .submit-btn {
    padding: 5px 18px;
    margin-right: 0;
  }
}

::v-deep .el-dialog__header {
  padding: 0 !important;
}

.info-box {
  background: #f6f6f8;
  border-radius: 5px;
}

.border-bottom {
  border-bottom: 1px solid #F7F7F7;
}

.popup1 {
  .label {
    width: 80px;
  }

  .btn {
    background: #f6f6f8;
    border-radius: 5px;
    padding: 8px 31px;
    color: #407aff;
    cursor: pointer;

    &:hover {
      background: #407aff;
      color: #fff;
      transition: all ease-in 0.2s;
    }
  }

  .submit-btn {
    padding: 8px 31px;

  }
}

.order-item {
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);
  padding: 0 20px 20px;

  .row-line {
    width: 100%;
    height: 1px;
    background: #F7F7F7;
    margin: 10px 0;
  }

  .order-img {
    width: 87px;
    height: 80px;
    border-radius: 5px;
  }

  .submit-btn {
    padding: 6px 22px;
  }

  .order-status-tag {
    position: absolute;
    right: 20px;
    top: 0;
    background: #e9f2ff;
    border-radius: 0 0 10px 10px;
    color: #407AFF;
    font-size: 14px;
    padding: 5px 20px;
  }
}

.sys-item {
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);

  .submit-btn {
    padding: 6px 22px;
  }
}


.money-text {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
